import React from 'react'
import withIcon from '@/components/withIcon'

function IconBriefcase({ className }) {
  return (
    <svg
      className={className}
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.58594 1.43945C5.75767 1.43945 5.08594 2.11062 5.08594 2.93921V3.43945H1.58594C0.757511 3.43945 0.0859375 4.11103 0.0859375 4.93945V6.32359L7.69944 8.35386C7.95268 8.42139 8.21919 8.42139 8.47243 8.35386L16.0859 6.32359V4.93945C16.0859 4.11103 15.4144 3.43945 14.5859 3.43945H11.0859V2.93921C11.0859 2.11062 10.4142 1.43945 9.58594 1.43945H6.58594ZM6.58594 2.43945H9.58594C9.86224 2.43945 10.0859 2.66408 10.0859 2.94007V3.43945H6.08594V2.93921C6.08594 2.66323 6.30964 2.43945 6.58594 2.43945Z"
        fill="currentColor"
      />
      <path
        d="M0.0859375 12.9395C0.0859375 13.7679 0.757511 14.4395 1.58594 14.4395H14.5859C15.4144 14.4395 16.0859 13.7679 16.0859 12.9395V7.28865L8.21477 9.38763C8.13036 9.41014 8.04152 9.41014 7.95711 9.38763L0.0859375 7.28865V12.9395Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default withIcon(IconBriefcase)
